import './main.scss';
import './icons';
import Vue from 'vue'
import i18n, {availableLocales, defaultLocale} from './i18n/i18n.config';
import VueMeta from 'vue-meta';
import AppComponent from '@/components/app/app.vue'
import Router from '@/router.ts'
import * as VueGoogleMaps from 'vue2-google-maps';
import SectionTitleComponent from '@/components/common/section-title/section-title.vue';
import DividerComponent from '@/components/common/divider/divider.vue';

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyC9ToRZvmmuYV7HRT37XeGU7E0GaUgDmqM',
        region: 'PL',
        language: getMapLocale()
    },
    installComponents: true
});

Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
});

new Vue({
    router: Router,
    i18n,
    render: h => h(AppComponent),
    components: {
        'section-title': SectionTitleComponent,
        'divider': DividerComponent
    },
    created() {
        document.documentElement.setAttribute('lang', i18n.locale);
    }
}).$mount('#app');

function getMapLocale() {
    const path = location.pathname;
    let result = defaultLocale;
    availableLocales.forEach(locale => {
        if (path.match(`/${locale}/?.*?`)) {
            result = locale;
            return false;
        }
    });
    return result;
}
